import { checkRequirements } from '@ca/common'

export default checkRequirements
